import { useEffect, useState } from "react";

export const useUserCountry = () => {
    const [country, setCountry] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [geoCode, setGeoCode] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const res = await fetch("https://ipapi.co/json/");
                if (!res.ok) throw new Error("Failed to fetch location");
                const data = await res.json();
                const geo_code = { latitude: data.latitude, longitude: data.longitude };
                setGeoCode(geo_code);
                setCountry(data.country_code);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCountry();
    }, []);

    return { country, isLoading, error, geoCode };
};
